<template>
  <div class="box">
    <!--原手机号-->
    <div class="original_number">
      <!--账号-->
      <div class="number">
        原手机号:
      </div>
      <div class="number_value">
        {{ mobile }}
      </div>
    </div>
    <!--手机号-->
    <div class="personInfo_phone">
      <input
        class="phone_number"
        v-model="phoneNumber"
        @input="changePhoneNumber"
        type="text"
        v-bind:placeholder="phoneNumberText"
      />
    </div>
    <!--验证码-->
    <div class="phone_verify">
      <!--验证码-->
      <input
        class="verify_value"
        v-model="phoneCode"
        @input="changePhoneCode"
        type="text"
        v-bind:placeholder="phoneCodeText"
      />
      <div v-if="isShow1" class="verify_code" @click="getSmsCode">
        获取验证码
      </div>
      <van-count-down
        v-if="isShow2"
        @finish="showButton"
        class="verify_code"
        :time="time"
        format="ss"
      />
    </div>
    <van-button class="box_button_text" @click="changePhoneBinding"
      >确认修改</van-button
    >
  </div>
</template>

<script>
export default {
  name: "changeNumber",
  data() {
    return {
      phoneNumberText: "请输入新的手机号",
      phoneCodeText: "请输入验证码",
      mobile: this.mobile, //原手机号
      phoneNumber: "", //手机号
      phoneCode: "", //输入验证码
      smCode: "", //获取的验证码
      time: 60 * 1000,
      isShow1: true,
      isShow2: false,
    };
  },
  mounted() {
    this.userInfo = this.$route.query.userInfo;
    this.mobile = this.userInfo.mobile;
  },
  mounted() {
    this.init();
  },
  methods: {
    //返回
    backToLast() {
      this.$router.go(-1);
    },
    init: function() {
      this.userInfo = this.$store.state.userInfo_v2.user;
      this.userName = this.userInfo.userName;
      this.mobile = this.userInfo.mobile;
    },

    changePhoneNumber() {
      console.log(this.phoneNumber);
      this.$emit("changePhoneNumber", this.phoneNumber);
    },
    changePhoneCode() {
      console.log(this.phoneCode);
      this.$emit("changePhoneCode", this.phoneCode);
    },
    //获取验证码
    getSmsCode() {
      var params = {
        phone: this.phoneNumber,
      };
      this.isShow1 = false;
      this.isShow2 = true;
      this.$API.x_person.getSmsCode(params).then((res) => {});
    },
    //重置按钮
    showButton() {
      this.isShow1 = true;
      this.isShow2 = false;
    },
    //确认修改
    changePhoneBinding() {
      try {
        if (this.phoneNumber == "" || this.phoneNumber == undefined) {
          this.$toast("请输入新的手机号");
          return;
        }
        if (this.phoneCode == "" || this.phoneCode == undefined) {
          this.$toast("请输入验证码");
          return;
        }

        let params = {
          accId: this.accId,
          mobile: this.phoneNumber,
          smsCode: this.phoneCode,
          oldPhone: this.mobile,
        };
        this.$API.x_person.changePhoneBinding(params);
        this.$toast("修改成功");
        this.$router.go(-1);
      } catch (e) {
        this.$toast("修改失败" + e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  background-color: #f4f6f9;
  height: 100%;

  .original_number {
    background-color: #ffffff;
    margin-top: vw(2);
    width: 100%;
    height: vw(110);
    display: flex;
    text-align: center;
    flex-direction: row;

    .number {
      margin-top: vw(40);
      margin-left: vw(32);
      color: #333333;
      font-size: vw(30);
      font-family: Source Han Sans CN;
      color: #333333;
      opacity: 1;
    }

    .number_value {
      margin-top: vw(40);
      margin-left: vw(20);
      color: #333333;
      font-size: vw(30);
      font-family: Source Han Sans CN;
      color: #333333;
      opacity: 1;
    }
  }

  .personInfo_phone {
    background-color: #ffffff;
    width: 100%;
    height: vw(110);
    margin-top: vw(20);
    .phone_number {
      background-color: #ffffff;
      color: #333333;
      font-size: vw(30);
      border: none;
      height: vw(110);
      margin-left: vw(32);
    }
  }

  .phone_verify {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    padding-left: vw(32);
    padding-right: vw(32);
    height: vw(110);
    margin-top: vw(5);
    background-color: #ffffff;
    .verify_value {
      background-color: #ffffff;
      border: none;
      color: #c2c5cc;
      font-size: vw(30);
      height: vw(110);
      color: #333333;
    }
    .verify_code {
      color: $theme-color;
      font-size: vw(28);
      font-family: Source Han Sans CN;
    }
  }

  .box_button_text {
    position: absolute;
    left: 8%;
    bottom: vw(30);
    width: 84%;
    height: vw(88);
    line-height: vw(88);
    background-color: $theme-color;
    font-size: vw(30);
    font-family: Source Han Sans CN;
    color: #ffffff;
    border-radius: vw(8);
  }
}
</style>
